import { crmRequest } from '@meta-vue/util'

// 最好由后端提供一个获取视频第一帧的接口
export const getVideoBase64 = url => {
  return new Promise((resolve, reject) => {
    let dataURL = ''
    const video = document.createElement('video')
    video.setAttribute('crossOrigin', 'anonymous') //处理跨域
    video.setAttribute('src', url)
    video.setAttribute('width', 400)
    video.setAttribute('height', 240)
    video.setAttribute('preload', 'auto')
    video.addEventListener('loadeddata', () => {
      const canvas = document.createElement('canvas')
      const width = video.width //canvas的尺寸和图片一样
      const height = video.height
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(video, 0, 0, width, height) //绘制canvas
      dataURL = canvas.toDataURL('image/jpeg') //转换为base64
      resolve(dataURL)
    })
  })
}

// 根据相对路径获取绝对路径
export const getAbsoluteUrl = data =>
  crmRequest(`${process.env.VUE_APP_FILE_UPLOAD}/ymm-file-app/fileUpload/get/file/absoluteUrl`, {
    method: 'post',
    data,
    getter: {
      data: 'model'
    }
  })
